/* Built In Imports */

/* External Imports */
import { Box, Flex, SimpleGrid, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import SectionTitle from '@app-ila/components/Text/SectionTitle';
import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';

/* Styles */

/**
 * Renders HMMApproach component
 * @param {Object}
 * @returns {ReactElement}
 */
const HMMApproach = ({ sectionContent }) => {
  return (
    <Box pt={{ base: '30px', md: '40px', xl: '0px' }} pb={{ base: '30px', md: '40px', xl: '40px' }}> 
      <Box>
        <Flex
          flexDirection="column"
          position="relative"
          m="0 auto 20px auto"
          pt="10px"
          pl="16px"
          maxWidth="1170px"
          w={{ base:'90%', md:'100%' }}
        >
          <SectionTitle titleObj={sectionContent[0]} />
        </Flex>
      </Box>
      <ApproachCards cards={sectionContent[1].cards} />
    </Box>
  );
};

const ApproachCards = ({ cards }) => {
  return (
    <Box maxW="1170px" mx="auto" width="100%">
      <SimpleGrid
        columns={{ base: 1, md: 1, lg: 2 }}
        spacingY="16px"
        spacingX="0px"
        justifyItems="center"
      >
        {cards?.map((secCon, index) => {
          const isLastOddCard =
            cards.length % 2 === 1 && index === cards.length - 1;
          return (
            <Box
              textColor="#fff"
              pos="relative"
              key={nanoid()}
              w={{base:'90%', lg:'100%'}}
              maxW="536px"
              display="flex"
              justifyContent={
                isLastOddCard ? { base: 'center', lg: 'center' } : 'flex-start'
              }
              gridColumn={isLastOddCard ? { lg: '1 / -1' } : undefined}
              padding={{base:'0 16px', lg:'0'}}
            >
              <Box
                background={'#2E225C'}
                p={{ base: '20px 30px', lg: '30px 100px' }}
              >
                <Box
                  fontSize="21px"
                  lineHeight="26px"
                  fontWeight="semibold"
                  letterSpacing="0em"
                  textAlign="center"
                  fontFamily="var(--FedraSansStd-book), sans-serif"
                >
                  {secCon.title}
                </Box>
                <Box
                  fontSize="18px"
                  lineHeight="160%"
                  fontWeight={400}
                  letterSpacing="0em"
                  textAlign="center"
                  p="10px 16px"
                >
                  <StructuredTextParser
                    str={render(secCon.description)}
                    region="in"
                    lang="en"
                    mt="0"
                    color="#ffffff"
                    textAlign="center"
                  />
                </Box>
              </Box>
            </Box>
          );
        })}
      </SimpleGrid>
    </Box>
  );
};

export default HMMApproach;
